<template>
    <div class="border border-keyline-primary hover:border-black dark:hover:border-white duration-150 bg-gray-tier-5 flex flex-col group overflow-hidden relative rounded-lg type-primary">
        <button
            @click.stop.prevent="getResource($event, res)"
            tabindex="-1"
            class="block h-32 overflow-hidden w-full at1024:h-[170px]"
        >
            <img
                :src="thumbnail"
                alt=""
                class="h-full object-cover opacity-90 transition-opacity w-full group-hover:opacity-100"
            />
        </button>

        <div class="absolute bg-white flex items-center justify-center h-8 right-4 rounded-full top-4 w-8">
            <BaseSvg
                :name="resourceTypeIcon"
                class="fill-gray h-5 w-5 group-hover:fill-black"
            />
        </div>

        <div class="flex flex-col grow p-[18px] relative font-medium">
            <div
                class="overflow-hidden type-secondary text-base"
                v-if="res.vendors[0].name"
            >
                {{ res.vendors[0].name }}
            </div>
            <button
                @click.stop.prevent="getResource($event, res)"
                class="leading-tight text-left text-lg at1024:leading-[27.6px] at1024:text-[23px]"
            >
                {{ res.name }}
            </button>
            <template v-if="user">
                <div class="hidden group-hover:block absolute top-0 right-0 p-4 bg-gray-tier-5">
                    <button @click="toggle">
                        <BaseSvg name="icon-more-horiz" />
                    </button>
                    <Popover ref="op" :pt="{
                        transition: {
                            enterActiveClass: 'menu-fade-enter-active',
                            enterFromClass: 'menu-fade-enter-from',
                            enterToClass: 'menu-fade-enter-to',
                            leaveActiveClass: 'menu-fade-leave-active',
                            leaveFromClass: 'menu-fade-leave-from',
                            leaveToClass: 'menu-fade-leave-to'
                        }
                    }">
                        <div class="flex flex-col gap-4 w-fit h-10">
                            <Pin type="resource" :id="res.id" :label="true" class="w-44"/>
                        </div>
                    </Popover>
                </div>
            </template>
<!--            <template v-if="user">-->
<!--                <div class="absolute right-4 top-2" v-click-outside="close">-->
<!--                    <button @click.stop.prevent="toggleOptions" class="group">-->
<!--                        <BaseSvg name="icon-more-horiz" class="fill-gray-400 group-hover:fill-black dark:group-hover:fill-white"/>-->
<!--                        <span class="sr-only">Result options</span>-->
<!--                    </button>-->
<!--                    <div v-show="optionsVisible" class="absolute right-0 text-sm top-full w-[175px]">-->
<!--                        <Pin type="resource" :id="res.id" :label="true"/>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </template>-->
        </div>
    </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {BaseSvg, Pin, TableActionsButton} from "@/Components";
import {eventBus, useAssetTransforms, useResources, useUser} from "@/Composables";
import Popover from 'primevue/popover';

const { user } = useUser();
const { getResource, transformElasticSearchResource } = useResources();

const props = defineProps({
    resource: {
        type: Object,
        required: true,
    },
    elasticsearch: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const { marketingAssetPdfThumbnail, youTubeThumbnail } = useAssetTransforms();

const optionsVisible = ref(false);

const toggleOptions = () => {
    optionsVisible.value = !optionsVisible.value;
    eventBus.emit('resource:options-toggled',res.value.id)
};

const onOptionsToggled = (resource_id) => {
    if(resource_id !== res.value.id) {
        close()
    }
};

const close = () => {
    optionsVisible.value = false
};

const res = computed(() => {
    if (props.elasticsearch) {
        return transformElasticSearchResource(props.resource);
    } else {
        return props.resource;
    }
});

const thumbnail = computed(() => {
    switch (res.value.asset.source) {
        case 3:
            return marketingAssetPdfThumbnail(
                res.value.asset.external_id,
                "c_fill,g_north,h_500,w_1000"
            );
        case 4:
            return youTubeThumbnail(res.value.asset.external_id);
        default:
            return null;
    }
});

const resourceTypeIcon = computed(() => {
    switch (res.value.asset.source) {
        case 3:
            return "icon-description";
        case 4:
            return "icon-movie";
        default:
            return null;
    }
});

onMounted(() => {
    eventBus.on('resource:options-toggled', onOptionsToggled);

    eventBus.on('pins:pin-toggled-on', close);
    eventBus.on('pins:pin-toggled-off', close);
})

//dropdown
const op = ref();
const toggle = (event) => {
    op.value.toggle(event);
}

</script>

<style>
/* .vendor-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
} */

.p-popover:after , .p-popover:before {
    display: none !important;
}
</style>
